const ESIGN_ALLOWED_EXTENSIONS = new Set(['pdf', 'doc', 'docx'])

export function isFileNameEsignSupported(
	fileName: string | undefined | null,
): boolean {
	if (typeof fileName !== 'string' || !fileName?.trim()) return false
	const trimmed = fileName?.trim()
	const dot = trimmed.lastIndexOf('.')
	if (dot < 0 || dot === trimmed?.length - 1) return false
	const ext = trimmed.slice(dot + 1).toLowerCase()
	return ESIGN_ALLOWED_EXTENSIONS.has(ext)
}

// Filename from Content-Disposition or URL
export function inferFilenameFromResponse(res: Response, url: string): string {
	const cd = res.headers.get('content-disposition') || ''
	const m = cd.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
	if (m?.[1]) {
		try {
			return decodeURIComponent(m[1].replace(/^"+|"+$/g, ''))
		} catch {
			return m[1]
		}
	}
	const tail = new URL(url).pathname.split('/').pop() || 'document.pdf'
	return tail.includes('.') ? tail : `${tail}.pdf`
}
